import React from 'react';
import PropTypes from 'prop-types';
import {Grid} from 'semantic-ui-react';
import styled from 'styled-components';
import {DefaultButton} from '../../components/Button/ButtonMix';
import {BRIGHT_RED, DARK_GREEN, LIGHT_GREEN, LIGHT_RED, YELLOW} from '../../components/Container/ContainerMix';
import GrinningFace from '../../components/SVG/GrinningFace.svg';
import SmilingFace from '../../components/SVG/SmilingFace.svg';
import WearyFace from '../../components/SVG/WearyFace.svg';
import StraightFace from '../../components/SVG/StraightFace.svg';
import ExplodingHead from '../../components/SVG/ExplodingHead.svg';
import DefaultFace from '../../components/SVG/DefaultFace.svg';

const EMOJIS = {
  0: DefaultFace,
  1: GrinningFace,
  2: SmilingFace,
  3: StraightFace,
  4: WearyFace,
  5: ExplodingHead
};

const StyledGrid = styled(Grid)`
  &.ui.container{
    margin: 0 !important;
  }
  @media only screen and (max-width: 767px) {
    padding: 0 2rem !important;
  }
`;

const Column = styled(Grid.Column)`
  padding-left: 5px !important;
  padding-right: 5px !important;
`;

const NumberButton = styled(DefaultButton)`
  padding-left: 0 !important;
  padding-right: 0 !important;
  background-color: ${props => props.active ? `${props.activecolor} !important` : '#C0C1C2'}
  color: ${props => props.active ? '#ffffff !important' : 'rgb(242, 242, 242);'}
`;

const Emoji = styled.img`
  width: 100%;
  height: 200px;
  text-align: center;
`;

const StressLevels = ({onSelect, selected}) => {
  const buildColumn = (value, activeColor) => {
    const isActive = selected === value;
    return (
      <Column>
        <NumberButton active={isActive} activecolor={activeColor} size="huge" circular onClick={() => onSelect(value)}>{value}</NumberButton>
      </Column>
    );
  };
  
  return (
    <div>
      <Emoji src={EMOJIS[selected]}/>
      <StyledGrid container columns={5}>
        <Grid.Row>
          {buildColumn(1, DARK_GREEN)}
          {buildColumn(2, LIGHT_GREEN)}
          {buildColumn(3, YELLOW)}
          {buildColumn(4, LIGHT_RED)}
          {buildColumn(5, BRIGHT_RED)}
        </Grid.Row>
      </StyledGrid>
    </div>
  );
};
StressLevels.propTypes = {
  onSelect: PropTypes.func.isRequired,
  selected: PropTypes.number
};

export default StressLevels;



// WEBPACK FOOTER //
// ./src/pages/Stress/StressLevels.js